<nav class="navbar head-nav mb-0">
  <h2>{{ 'user_management.user_preferences' | translate }}</h2>
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]='["/"]'>{{ 'header.home' | translate }}</a></li>
    <li class="breadcrumb-item">{{ 'user_management.user_preferences' | translate }}</li>
  </ol>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
<div class="app--content-container">
  <form [formGroup]="formGroup">
    <div>
      <div class="card_field_group">
        <div class="card_content">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="fields-group">
                <h3 class="label_field">
                  {{ 'user_management.time_zone' | translate }}
                </h3>
                <div class="form-group">
                  <mat-form-field [class.loading-field]='dataLoading'>
                    <mat-select disableOptionCentering formControlName="timeZoneId" [disabled]="dataLoading">
                      <mat-option [value]="item.id" *ngFor="let item of timeZoneList">
                        <span>{{item.timeZoneGMT}}</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('timeZoneId', 'required')">
                      {{ 'forms.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="fields-group">
                <h3 class="label_field">
                  {{ 'user_management.date_format' | translate }}
                </h3>
                <div class="form-group">
                  <mat-form-field>
                    <mat-select disableOptionCentering formControlName="dateFormat">
                      <mat-option [value]="item.value" *ngFor="let item of dateFormatList">
                        <span>{{item.name}}</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('dateFormat', 'required')">
                      {{ 'forms.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="fields-group">
                <h3 class="label_field">
                  {{ 'user_management.language' | translate }}
                </h3>
                <div class="form-group">
                  <mat-form-field [class.loading-field]='dataLoading'>
                    <mat-select disableOptionCentering formControlName="languageId" [disabled]="dataLoading">
                      <mat-option [value]="item.id" *ngFor="let item of languageList">
                        <span>{{item.language}}</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('languageId', 'required')">
                      {{ 'forms.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="fields-group">
                <h3 class="label_field">
                  {{ 'user_management.theme' | translate }}
                </h3>
                <div class="form-group">
                  <mat-form-field>
                    <mat-select disableOptionCentering formControlName="theme">
                      <mat-option [value]="item.value" *ngFor="let item of themeList">
                        <span>{{item.name}}</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('theme', 'required')">
                      {{ 'forms.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="fields-group">
                <h3 class="label_field">
                  {{ 'user_management.layout' | translate }}
                </h3>
                <div class="form-group">
                  <mat-form-field>
                    <mat-select disableOptionCentering formControlName="layout">
                      <mat-option [value]="item.value" *ngFor="let item of layoutList">
                        <span>{{item.name}}</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasError('layout', 'required')">
                      {{ 'forms.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-container d-flex justify-content-end">
          <button mat-raised-button color="primary" class="mr-2" [disabled]="loading" [class.loading]='loading'
            (click)="saveRecord()">
            {{ 'forms.save' | translate }}
          </button>
          <a mat-raised-button color="grey" [routerLink]="['/admin/myprofile']" [disabled]="loading">
            {{ 'swalMsg.cancel' | translate }}
          </a>
        </div>
      </div>
    </div>

  </form>
</div>